var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTwitterDesktopStreamShare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 15,
  height: 15,
  viewBox: "0 0 15 15",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M14.43 8.36a.57.57 0 0 1 .563.478L15 8.93v3.5a2.57 2.57 0 0 1-2.407 2.565L12.43 15H2.57a2.57 2.57 0 0 1-2.565-2.407L0 12.43v-3.5a.57.57 0 0 1 1.133-.092l.007.092v3.5a1.43 1.43 0 0 0 1.292 1.423l.138.007h9.86a1.43 1.43 0 0 0 1.423-1.292l.007-.138v-3.5a.57.57 0 0 1 .57-.57M7.86.08l.085.061 4 3.5a.57.57 0 0 1-.667.919l-.083-.061L8.14 1.826V9.57a.57.57 0 0 1-1.133.092L7 9.57V1.826L3.945 4.499a.57.57 0 0 1-.73.017l-.074-.07a.57.57 0 0 1-.017-.73l.07-.075 4-3.5A.57.57 0 0 1 7.86.079"
})));
export default SvgTwitterDesktopStreamShare;